// extracted by mini-css-extract-plugin
module.exports = {"container":"Zi","heading":"_i","linkBtn":"aj","disabled":"bj","linkUppercaseBold":"cj","copy":"dj","links":"ej"};